import { Stats as StatsSDS } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import { useEntranceAnimation } from '../Animations/useEntranceAnimation';
import type { StatsDataProps } from './types';

export const Stats: FC<StatsDataProps> = props => {
  const { stat, entranceAnimation } = props;

  const { animation, styles } = useEntranceAnimation(entranceAnimation);

  return <StatsSDS stat={stat} animation={animation} style={styles} />;
};
